


































import { computed } from '@nuxtjs/composition-api';
import { defineComponent } from '@vue/composition-api';
import { useCartAttributes } from '~/features/cart';
import { useGiftTiers } from '~/features/gift-tiers';

export default defineComponent({
  setup() {
    const { cartPriceRuleDiscounts, subtotal } = useCartAttributes();

    const nextLevelAmount = computed(() => {
      const eligibleTierIdx = cartPriceRuleDiscounts.value.eligibleTierIdx;

      // If there are no tiers, return 0
      if (!cartPriceRuleDiscounts.value.tiers || !cartPriceRuleDiscounts.value.tiers?.length) {
        return 0;
      }

      // If the last tier is eligible, return the last tier minimum subtotal
      if (eligibleTierIdx === cartPriceRuleDiscounts.value.tiers.length - 1) {
        return cartPriceRuleDiscounts.value.tiers?.[eligibleTierIdx]?.subtotalValue;
      }

      // If there are no eligible tiers or the first tier is eligible, return the first tier minimum subtotal
      if (eligibleTierIdx === 0) {
        return cartPriceRuleDiscounts.value.tiers?.[0]?.isApplied
          ? cartPriceRuleDiscounts.value.tiers?.[1]?.subtotalValue
          : cartPriceRuleDiscounts.value.tiers?.[0]?.subtotalValue;
      }

      // If the eligible tier is in the middle, return the next tier minimum subtotal
      return cartPriceRuleDiscounts.value.tiers?.[eligibleTierIdx + 1]?.subtotalValue;
    });

    const { amountRemaining, currentTier, nextTierDiscount, progressDone } = useGiftTiers(
      nextLevelAmount,
      subtotal,
      computed(() => cartPriceRuleDiscounts.value)
    );

    const promotionNotApplicable = computed(() => {
      // If current tier is 0 (i.e. no tier is applied) and subtotal surpasses minimum of first tier
      return currentTier.value === 0 && subtotal.value >= cartPriceRuleDiscounts.value.tiers?.[0]?.subtotalValue;
    });

    return {
      progressDone,
      cartPriceRuleDiscounts,
      nextLevelAmount,
      amountRemaining,
      subtotal,
      currentTier,
      nextTierDiscount,
      promotionNotApplicable,
    };
  },
});
